// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"12e5d732","194":"6e927650","339":"b9740d3d","446":"7059bff5","551":"5eacef47","614":"7017e965","693":"6ac65f37","718":"dc071485","719":"e104fab4","722":"587ef979","787":"0231af6f"}[chunkId] + ".chunk.js";
};